import { SearchUserHit } from 'lib-shared-types-api';

export type PresenceStatus = 'working' | 'away' | 'offline';

export const getStatus = (member: SearchUserHit): PresenceStatus =>
  member.is_online ? (member.is_working ? 'working' : 'away') : 'offline';
